import { Controller } from "@hotwired/stimulus";

// TODO:
// Make images optional
// Fix secondary up down arrow
// Rename this, it's not just for instructors

export default class extends Controller {
  static targets = [
    "currentItemWrapper",
    "currentItemName",
    "currentInstructorImage",
    "dropdown",
    "searchContainer",
    "searchInput",
    "instructorOutOfZoneDropdown",
    "instructorOutOfZoneDropdownArrow",
    "defaultImage",
  ];

  // Properties that track the current display properties of the UI
  areItemsExpanded = false;
  areSecondaryItemsExpanded = false;
  searchTerm = "";
  preFilterTerm = "";
  hasInteractedWith = false;

  connect() {
    // When the widget is first initialised, we should make sure the default item is broadcast as selected
    // to ensure that the desired selection behaviour on any parent components is triggered
    // set in a timeout so the event is not triggered before the parent component has had a chance to listen for it
    setTimeout(() => {
      const id = this.currentItemWrapperTarget.dataset.instructorId;
      const dispatchItemString =
        this.currentItemWrapperTarget.dataset.dispatchItem;
      let dispatchItem = { id: id };

      if (dispatchItemString && dispatchItemString.trim().length > 0) {
        try {
          dispatchItem = JSON.parse(dispatchItemString);
        } catch (error) {
          console.log(error);
        }
      }

      if (!(!id || id === "undefined" || id == "null" || id == "0")) {
        if (this.data.has("inputQuerySelector")) {
          try {
            const inputQuerySelector = this.data.get("inputQuerySelector");
            if (inputQuerySelector) {
              const inputElement = document.querySelector(inputQuerySelector);
              if (inputElement) {
                inputElement.value = id;
                inputElement.dataset.resourceLabel =
                  this.currentItemNameTarget.textContent?.trim() || "";
                if (this.hasInteractedWith) {
                  inputElement.dispatchEvent(new Event("input"));
                  inputElement.dispatchEvent(new Event("change"));
                }
              }
            }
          } catch (e) {
            console.log(e);
            console.log("Could not set input_query_selector value");
          }
        }
        if (this.data.has("jsonQuerySelector")) {
          try {
            const jsonQuerySelector = this.data.get("jsonQuerySelector");
            if (jsonQuerySelector) {
              const jsonElement = document.querySelector(jsonQuerySelector);
              if (jsonElement) {
                jsonElement.value = JSON.stringify(dispatchItem);
                if (this.hasInteractedWith) {
                  jsonElement.dispatchEvent(new Event("input"));
                  jsonElement.dispatchEvent(new Event("change"));
                }
              }
            }
          } catch (e) {
            console.log(e);
            console.log("Could not set json_query_selector value");
          }
        }

        this.element.dispatchEvent(
          new CustomEvent("itemSelected", {
            detail: {
              id: id,
              dispatchItem: dispatchItem,
            },
          })
        );
      }

      if (
        this.data.has("filterQuerySelector") &&
        this.data.get("filterQuerySelector")
      ) {
        const filterQuerySelector = this.data.get("filterQuerySelector");
        const filterElement = document.querySelector(filterQuerySelector);
        if (filterElement) {
          console.log(filterElement);
          // if filterElement is <input class="mb2" type="text" id="instructor_id">
          filterElement.addEventListener("input", (event) => {
            this.preFilterItems(event.target.value);
          });
        }

        setTimeout(() => {
          const filterElement = document.querySelector(filterQuerySelector);

          console.log("filterElement");
          console.log(filterElement);

          if (filterElement) {
            this.preFilterItems(filterElement.value);
          }
        });
      }

      // json-input-query-selector
      if (
        this.data.has("jsonInputQuerySelector") &&
        this.data.get("jsonInputQuerySelector")
      ) {
        try {
          const jsonInputQuerySelector = this.data.get("jsonInputQuerySelector");
          const jsonInputElement = document.querySelector(
            jsonInputQuerySelector
          );
          if (jsonInputElement) {
            console.log(jsonInputElement);
            // if jsonInputElement is <input class="mb2" type="text" id="instructor_data">
            jsonInputElement.addEventListener("input", (event) => {
              
              // Get the currently selected id
              let currentId = null;
              try {
                currentId = this.currentItemWrapperTarget.dataset.instructorId;
              } catch (e) {
                console.log("No current id");
              }
              if(currentId && currentId !== "0") return; // Don't change selection if an item is already selected

              const obj = JSON.parse(event.target.value);
              const id = obj.id;
              const name = obj.name;
              const image = obj.image;
              this.selectItem({
                currentTarget: {
                  dataset: {
                    instructorId: id,
                    instructorName: name,
                  },
                  getElementsByTagName: () => [
                    {
                      src: image,
                    },
                  ],
                },
              }, false);
            });

            jsonInputElement.addEventListener("change", (event) => {
              
              // Get the currently selected id
              let currentId = null;
              try {
                currentId = this.currentItemWrapperTarget.dataset.instructorId;
              } catch (e) {
                console.log("No current id");
              }
              if(currentId && currentId !== "0") return; // Don't change selection if an item is already selected

              const obj = JSON.parse(event.target.value);
              const id = obj.id;
              const name = obj.name;
              const image = obj.image;
              this.selectItem({
                currentTarget: {
                  dataset: {
                    instructorId: id,
                    instructorName: name,
                  },
                  getElementsByTagName: () => [
                    {
                      src: image,
                    },
                  ],
                },
              }, false);
            });
          }
        } catch (e) {
          console.log(e);
          console.log("Could not set json_input_query_selector listener");
        }
      }
    });
  }

  forceSelectItem(event) {
    if (!event.detail.id || event.detail.id === "0" || event.detail.id === 0) {
      this.selectNothing();
      return;
    }

    const primaryItem = this.element.querySelector(
      `.primary-item[data-instructor-id='${event.detail.id}']`
    );
    const secondaryItem = this.element.querySelector(
      `.secondary-items[data-instructor-id='${event.detail.id}']`
    );

    if (primaryItem) {
      this.selectItem({ currentTarget: primaryItem }, false);
    } else if (secondaryItem) {
      this.selectItem({ currentTarget: secondaryItem }, false);
    } else {
      console.log("No item found with id: ", event.detail.id);
    }
  }

  forceSelectFirstFilteredItem(filterTag, interact = false) {
    // search for either a primary item or secondary item with the right data-instructor-id
    const primaryItem = this.element.querySelector(
      `.primary-item[data-filter-tag='${filterTag}']`
    );
    const secondaryItem = this.element.querySelector(
      `.secondary-items[data-filter-tag='${filterTag}']`
    );

    if (primaryItem) {
      this.selectItem({ currentTarget: primaryItem }, interact);
    } else if (secondaryItem) {
      this.selectItem({ currentTarget: secondaryItem }, interact);
    } else {
      this.selectNothing();
    }
  }

  addBadge(event) {
    this.element.querySelectorAll(`.Badge`).forEach((element) => {
      if (
        !event.detail.id ||
        element.dataset.instructorId === `${event.detail.id}`
      ) {
        element.classList = "";
        event.detail.badgeClasses.forEach((badgeClass) => {
          element.classList.add(badgeClass);
        });
        element.innerHTML = event.detail.badgeText;
      }
    });
  }

  toggleSelection(event) {
    console.log("toggleSelection");
    this.areItemsExpanded = !this.areItemsExpanded;
    this.setDisplayProperties();
  }

  // This function is used to hide items before a user can even select them
  preFilterItems(filterString) {
    const oldFilterTag = this.preFilterTerm;
    this.preFilterTerm = filterString;
    console.log("preFilterItems");
    if (oldFilterTag !== filterString) {
      this.setDisplayProperties();
      this.forceSelectFirstFilteredItem(filterString, true);
    }
  }

  filter(event) {
    this.searchTerm = event.currentTarget.value;
    console.log(this.searchTerm);
    this.setDisplayProperties();
  }

  toggleSecondarySelection() {
    this.areSecondaryItemsExpanded = !this.areSecondaryItemsExpanded;
    this.setDisplayProperties();
  }

  selectNothing() {
    const id = 0;
    const dispatchItem = {};
    const name = this.data.get("selectAnItemText");
    const image = this.defaultImageTarget.src;

    this.currentItemWrapperTarget.dataset.instructorId = id;
    this.currentItemNameTarget.innerHTML = name;
    this.currentInstructorImageTarget.src = image;

    this.closeSelection();

    if (this.data.has("inputQuerySelector")) {
      try {
        const inputQuerySelector = this.data.get("inputQuerySelector");
        const inputElement = document.querySelector(inputQuerySelector);
        inputElement.value = id;
        inputElement.dataset.resourceLabel = name;
        if (this.hasInteractedWith) {
          inputElement.dispatchEvent(new Event("input"));
          inputElement.dispatchEvent(new Event("change"));
        }
      } catch (e) {
        console.log(e);
        console.log("Could not set input_query_selector value");
      }
    }
    if (this.data.has("jsonQuerySelector")) {
      try {
        const jsonQuerySelector = this.data.get("jsonQuerySelector");
        const jsonElement = document.querySelector(jsonQuerySelector);
        jsonElement.value = JSON.stringify({ id, name, image });
        if (this.hasInteractedWith) {
          jsonElement.dispatchEvent(new Event("input"));
          jsonElement.dispatchEvent(new Event("change"));
        }
      } catch (e) {
        console.log(e);
        console.log("Could not set json_query_selector value");
      }
    }

    this.element.dispatchEvent(
      new CustomEvent("itemSelected", {
        detail: {
          id: id,
          dispatchItem: dispatchItem,
        },
      })
    );
  }

  selectItem(event, interact = true) {
    if (interact) {
      this.hasInteractedWith = true;
    }
    const id = event.currentTarget.dataset.instructorId;
    const dispatchItemString = event.currentTarget.dataset.dispatchItem;
    let dispatchItem = { id: id };
    try {
      dispatchItem = JSON.parse(dispatchItemString);
    } catch (error) {
      console.log(error);
    }
    const name = event.currentTarget.dataset.instructorName;
    const image = event.currentTarget.getElementsByTagName("img")[0].src;

    this.currentItemWrapperTarget.dataset.instructorId = id;
    this.currentItemNameTarget.innerHTML = name;
    this.currentInstructorImageTarget.src = image;

    this.closeSelection();

    // If the parent element used input_query_selector, we should set the value of that input to the name of the selected item
    if (this.data.has("inputQuerySelector")) {
      try {
        const inputQuerySelector = this.data.get("inputQuerySelector");
        if (inputQuerySelector) {
          const inputElement = document.querySelector(inputQuerySelector);
          if (inputElement) {
            inputElement.value = id;
            inputElement.dataset.resourceLabel = name;
            if (this.hasInteractedWith) {
              inputElement.dispatchEvent(new Event("input"));
              inputElement.dispatchEvent(new Event("change"));
            }
          }
        }
      } catch (e) {
        console.log(e);
        console.log("Could not set input_query_selector value");
      }
    }
    if (this.data.has("jsonQuerySelector")) {
      try {
        const jsonQuerySelector = this.data.get("jsonQuerySelector");
        if (jsonQuerySelector) {
          const jsonElement = document.querySelector(jsonQuerySelector);
          if (jsonElement) {
            jsonElement.value = JSON.stringify({ id, name, image });
            if (this.hasInteractedWith) {
              jsonElement.dispatchEvent(new Event("input"));
              jsonElement.dispatchEvent(new Event("change"));
            }
          }
        }
      } catch (e) {
        console.log(e);
        console.log("Could not set json_query_selector value");
      }
    }

    this.element.dispatchEvent(
      new CustomEvent("itemSelected", {
        detail: {
          id: id,
          dispatchItem: dispatchItem,
        },
      })
    );
  }

  closeSelection() {
    this.areItemsExpanded = false;
    this.setDisplayProperties();
  }

  setDisplayProperties() {
    const showSearch = this.areItemsExpanded;
    this.searchContainerTarget.style.height = showSearch ? "50px" : "0px";

    const rotateDropdown = this.areItemsExpanded;
    this.dropdownTarget.style.transform = rotateDropdown
      ? "rotate(180deg)"
      : "rotate(360deg)";

    const rotateOutOfZoneDropdown = this.areInstructorsOutOfZoneExpanded;
    this.instructorOutOfZoneDropdownArrowTarget.style.transform =
      rotateOutOfZoneDropdown ? "rotate(180deg)" : "rotate(360deg)";

    const showSecondaryDropdown = this.areItemsExpanded;
    this.instructorOutOfZoneDropdownTarget.style.height = showSecondaryDropdown
      ? "30px"
      : "0px";

    const showOutOfZoneInstructors =
      this.areItemsExpanded && this.areSecondaryItemsExpanded;
    const outOfZoneInstructors =
      this.element.getElementsByClassName("secondary-items");

    let outOfZoneCount = 0;
    for (let i = 0; i < outOfZoneInstructors.length; i++) {
      const element = outOfZoneInstructors[i];
      const instructorName = element.dataset.instructorName;
      const filterTag = element.dataset.filterTag;
      const showThisInstructor =
        instructorName.toLowerCase().includes(this.searchTerm.toLowerCase()) &&
        (!this.preFilterTerm || filterTag == this.preFilterTerm);
      outOfZoneCount += showThisInstructor ? 1 : 0;
      element.style.height =
        showOutOfZoneInstructors && showThisInstructor ? "50px" : "0px";
    }

    if (outOfZoneCount === 0 && this.hasInstructorOutOfZoneDropdownTarget) {
      this.instructorOutOfZoneDropdownTarget.classList.add("u-hidden");
    } else {
      this.instructorOutOfZoneDropdownTarget.classList.remove("u-hidden");
    }

    const showInZoneInstructors = this.areItemsExpanded;
    const inZoneInstructors =
      this.element.getElementsByClassName("primary-item");
    // console.log(inZoneInstructors);
    for (let i = 0; i < inZoneInstructors.length; i++) {
      const element = inZoneInstructors[i];
      // console.log(element);
      const instructorName = element.dataset.instructorName;
      // console.log(instructorName);
      const showThisInstructor =
        instructorName.toLowerCase().includes(this.searchTerm.toLowerCase()) &&
        (!this.preFilterTerm ||
          element.dataset.filterTag == this.preFilterTerm);
      // console.log(showThisInstructor);
      element.style.height =
        showInZoneInstructors && showThisInstructor ? "50px" : "0px";
    }
  }
}
